import uuid from "@pdfking/workflow/utils/uuid"

export default (element: Element): string => {
  let id = element.getAttribute("data-uuid")
  if (!id) {
    id = uuid()
    element.setAttribute("data-uuid", id)
  }
  return id
}
